// Axios
import Axios from "./axios";

export const deleteNewsContentImage = (newsId) => {
  return new Promise((resolve, reject) => {
    const data = Axios.patch(`/news/${newsId}`, null, {
      headers: {
        "access-token": localStorage.getItem("access_token"),
      },
    });
    resolve(data);
  });
};
